import RestaurantsApi from '../api/restaurants'


import { addWarnNotification, addErrorNotification, addInfoNotification } from './notifications'

export const LOAD_RESTAURANT_REQUESTED = 'restaurantDetails/LOAD_RESTAURANT_REQUESTED'
export const LOAD_RESTAURANT = 'restaurantDetails/LOAD_RESTAURANT'
export const LOAD_RESTAURANT_ERROR = 'restaurantDetails/LOAD_RESTAURANT_ERROR'

export const UPDATE_RESTAURANTPOOL_REQUESTED = 'restaurantDetails/UPDATE_RESTAURANTPOOL_REQUESTED'
export const UPDATE_RESTAURANTPOOL = 'restaurantDetails/UPDATE_RESTAURANTPOOL'
export const UPDATE_RESTAURANTPOOL_ERROR = 'restaurantDetails/UPDATE_RESTAURANTPOOL_ERROR'

export const EDIT_RESTAURANTPOOL_STARTED = 'restaurantDetails/EDIT_RESTAURANTPOOL_STARTED'
export const EDIT_RESTAURANTPOOL_CANCELLED = 'restaurantDetails/EDIT_RESTAURANTPOOL_CANCELLED'
export const EDIT_RESTAURANTPOOL = 'restaurantDetails/EDIT_RESTAURANTPOOL'

export const LOAD_RESTAURANTLOGS_REQUESTED = 'restaurantDetails/LOAD_LOGS_REQUESTED'
export const LOAD_RESTAURANTLOGS = 'restaurantDetails/LOAD_LOGS'
export const LOAD_RESTAURANTLOGS_ERROR = 'restaurantDetails/LOAD_LOGS_ERROR'

export const LOAD_RESTAURANTSUMMARY_REQUESTED = 'restaurantDetails/LOAD_RESTAURANTSUMMARY_REQUESTED'
export const LOAD_RESTAURANTSUMMARY = 'restaurantDetails/LOAD_RESTAURANTSUMMARY'
export const LOAD_RESTAURANTSUMMARY_ERROR = 'restaurantDetails/LOAD_RESTAURANTSUMMARY_ERROR'

export const loadRestaurantAsync = (id) => {
  return dispatch => {
    dispatch({
      type: LOAD_RESTAURANT_REQUESTED,
      id: id,
    })
  
    Promise.all([
      RestaurantsApi.GetById(id).then(response => response.json()),
      RestaurantsApi.GetRestaurantPoolSchedule(id).then(response => response.json()),
    ]).then(([details, schedule]) => {
      dispatch({
        type: LOAD_RESTAURANT,
        id: id,
        data: {...details, poolSchedule:schedule.data},
      })
    }).catch(function (error) {
      dispatch({
        type: LOAD_RESTAURANT_ERROR,
        id: id,
        error: error.message
      })
      console.log('There has been a problem with your fetch operation: ', error)
    })
  }
}

export const updateRestaurantPoolScheduleAsync = (id, data) => {
  return dispatch => {
    dispatch({
      type: UPDATE_RESTAURANTPOOL_REQUESTED,
      id: id,
    })

    RestaurantsApi.UpdateRestaurantPoolSchedule(id, data)
    .then(response => {
      // Manually check for HTTP errors
      if (response.ok) {
        dispatch(addInfoNotification('Schedules Saved'));
      }else{
        dispatch(addErrorNotification('Error updating pool schedule', response.statusText));
      }
      return response;
    })
      .then(_ => RestaurantsApi.GetRestaurantPoolSchedule(id))
      .then(response => response.json())
      .then(json =>  {
        dispatch({
          type: UPDATE_RESTAURANTPOOL,
          id: id,
          data: json,
        })

        var restaurantData = json['data']
        var utcNow = new Date().toISOString()
        for (var i = 0; i < restaurantData.length; i++) {
          var restaurant = restaurantData[i];
          if (utcNow >= restaurant['startDateUtc']) {
            continue;
          }

          if (restaurant['pool'] !== null && restaurant['pool']['isActive'] === false) {
            dispatch(addWarnNotification(`Pool ${restaurant['pool']['name']} is inactive`))
          }
        }

      })
      .catch(function (error) {
        dispatch({
          type: UPDATE_RESTAURANTPOOL_ERROR,
          id: id,
          error: error.message
        })
        console.log('There has been a problem with your update operation: ', error)
      })
  }
}

export const startEditingPoolSchedule = (id) => {
  return dispatch => {
    dispatch({
      type: EDIT_RESTAURANTPOOL_STARTED,
      id: id,
    })
  }
}

export const cancelEditingPoolSchedule = (id) => {
  return dispatch => {
    dispatch({
      type: EDIT_RESTAURANTPOOL_CANCELLED,
      id: id,
    })
  }
}

export const editPoolSchedule = (id, poolSchedule) => {
  return dispatch => {
    dispatch({
      type: EDIT_RESTAURANTPOOL,
      id: id,
      data: {poolSchedule}
    })
  }
}

export const loadLogsAsync = (data) => {
  return dispatch => {
    dispatch({
      type: LOAD_RESTAURANTLOGS_REQUESTED,
      id: data.id,
      page: data.page,
      itemsPerPage: data.itemsPerPage,
      user: data.user
    })
  
    let offset = (data.page - 1) * data.itemsPerPage
  
    RestaurantsApi.GetLogs(data.id, offset, data.itemsPerPage)
      .then(response => {
        return response.json()
      })
      .then(json => dispatch({
        type: LOAD_RESTAURANTLOGS,
        data: json,
        user: data.user
      }))
      .catch(function (error) {
        dispatch({
          type: LOAD_RESTAURANTLOGS_ERROR,
          error: error.message
        })
        console.log('There has been a problem with your fetch operation: ', error)
      })
  }
}
   
export const loadRestaurantSummaryAsync = (data) => {
  return dispatch => {
    dispatch({
      type: LOAD_RESTAURANTSUMMARY_REQUESTED,
      id: data.id,
      user: data.user
    })
  
    RestaurantsApi.GetSummary(data.id)
      .then(response => {
        return response.json()
      })
      .then(json => dispatch({
        type: LOAD_RESTAURANTSUMMARY,
        data: json,
        user: data.user
      }))
      .catch(function (error) {
        dispatch({
          type: LOAD_RESTAURANTSUMMARY_ERROR,
          error: error.message
        })
        console.log('There has been a problem with your fetch operation: ', error)
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/restaurantDetails.js